import React, {HTMLInputTypeAttribute} from 'react';
import classNames from "classnames";


import './Input.css';


export interface SelectProps {
    value: string | number;
    min?: number;
    onChange?: (newValue: string) => void;
    disabled?: boolean;
    type?: HTMLInputTypeAttribute;
}


export const Input = (
    {
        value,
        onChange,
        disabled,
        type,
        min,
    }: SelectProps
) => {
    return (
        <input className={
            classNames({
                "Input body-large": true,
                "Input--disabled": disabled,
            })
        }
               onChange={(event) => {
                   onChange && onChange(event.target.value);
               }}
               disabled={disabled}
               value={value}
               type={type}
               min={min}
        />
    )
}
